enum Language {
  ACAD = "code",
  English = "en",
}

export default Language;
